var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('common-breadcrumb'),_c('div',{staticClass:"table-wrap"},[_vm._m(0),_c('queryMain')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-tab flex-space-between"},[_c('div',{staticClass:"tab-text"},[_vm._v("我的查询")])])
}]

export { render, staticRenderFns }